import API from "../../Api/Api.js";
import { closeModal } from "./confirmationModal.js";
import { handleError, handleInfo } from "./notifications.js";
import qs from "qs";
const token = localStorage.getItem("token");

export const getAllEvents = (filter) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: {
        title: {
          $containsi: filter,
        },
      },
      populate: {
        banner: {
          populate: "*",
        },
      },
      sort: ["createdAt:desc"],
    },

    {
      encodeValuesOnly: true,
    }
  );
  dispatch({ type: "EVENT_LOADING" });
  try {
    let { data } = await API.get("api/events?" + query);
    dispatch({ type: "FETCH_EVENTS", payload: data.data });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const deleteEvent = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  API.defaults.params = {};
  dispatch({ type: "EVENT_LOADING" });
  try {
    await API.delete(`api/events/${id}`);
    dispatch(getAllEvents());
    dispatch(closeModal());
  } catch (error) {
    dispatch(handleError("Error while deleting the event", 1));
    console.log(error);
  }
};

export const publishOrNoPublishEvent = (id, published) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  dispatch({ type: "EVENT_LOADING" });
  try {
    await API.put(`api/events/${id}`, { data: { publish: published } });
    dispatch(getEventItem(id));
    dispatch(getAllEvents());
    dispatch(closeModal());
    dispatch(
      handleInfo(published ? "Event published" : "Event unpublished", 1)
    );
  } catch (error) {
    dispatch(handleError("Error while publishing the event", 1));
    console.log(error);
  }
};

export const addEvent = () => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  API.defaults.params = {};
  let defaultImage = null;

  dispatch({ type: "EVENT_LOADING" });
  try {
    let image = await API.get("api/upload/files");
    defaultImage = image.data[0].id;
  } catch (error) {
    dispatch(handleError("Network error", 1));

    console.log(error);
  }

  try {
    if (!defaultImage) {
      return dispatch(
        handleError("Please import at least one image to proceed", 1)
      );
    }
    const defaultBanner = {
      title: "default banner",
      subtitle: "default subtitle",
      image: [defaultImage],
      imageMobile: [defaultImage],
    };

    let defaultArticleFR = {
      title: "default event title",
      subtitle: "default event subtitle",
      writer: "default author",
      writerImage: [defaultImage],
      description: "default description",
    };

    let defaultSEOFR = {
      title: "default SEO title",
      description: "default SEO description",
      ogimage: defaultImage,
    };

    let SEOfr = await API.post("/api/seos", {
      data: defaultSEOFR,
    });

    let bannerfr = await API.post("/api/sections", {
      data: defaultBanner,
    });

    await API.post("/api/events", {
      data: {
        banner: bannerfr.data.data.id,
        seo: SEOfr.data.data.id,
        ...defaultArticleFR,
      },
    });

    dispatch(handleInfo("Event created", 1));
    dispatch(getAllEvents());
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const getEventItem = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: { id: { $eq: id } },
      populate: {
        banner: {
          populate: "*",
        },
        sections: {
          populate: "*",
        },
        revendeurs: {
          populate: "*",
        },
        seo: {
          populate: "ogimage",
        },
      },
    },
    { encodeValuesOnly: true }
  );
  dispatch({ type: "EVENT_LOADING" });
  try {
    let { data } = await API.get("/api/events?" + query);

    dispatch({ type: "FETCH_EVENT_ITEM", payload: data.data[0] });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const updateEvent = (id, event) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  dispatch({ type: "EVENT_LOADING" });
  try {
    await API.put(`/api/events/${id}`, { data: event });

    dispatch(handleInfo("Event modified", 1));
    dispatch(getEventItem(id));
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const changeassociatedShowrooms =
  (id, associatedShowrooms) => async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;

    dispatch({ type: "EVENT_LOADING" });
    try {
      await API.put(`/api/events/${id}`, {
        data: { revendeurs: associatedShowrooms },
      });

      dispatch(handleInfo("Event modified", 1));
      dispatch(getEventItem(id));
    } catch (error) {
      dispatch(handleError("Network error", 1));
      console.log(error);
    }
  };
